<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

import { Data } from "../ts/AboutUs.interface";
import { ref, onMounted, onUnmounted, computed, watch } from "vue";
import { useMainStore } from "@/store/main/index";

const props = defineProps<{
  content: Data;
}>();

const mainStore = useMainStore();
let itemNum = 1;
let stepSize = 1;
let intervalId: NodeJS.Timer;

const currentItem = ref();
const rectTop = ref();
const stopDisplay = ref(false);
const computedRect = computed(() => rectTop?.value?.top);

watch(computedRect, (n) => {
  if (n + 100 < mainStore?.windowHeight && !stopDisplay.value) {
    if (!props?.content) return;
    stopDisplay.value = true;
    displayNumbers(Number(props?.content?.num));
  }
});

const displayNumbers = (max: number) => {
  stepSize = max / 50;
  intervalId = setInterval(() => {
    if (!max) {
      currentItem.value = 0;
      return;
    }
    if (itemNum + stepSize > max) {
      stepSize = max - itemNum;
    }
    if (itemNum === max) {
      clearInterval(intervalId);
    }
    itemNum += stepSize;
    currentItem.value = Math.ceil(itemNum);
  }, 50);
};

onMounted(() => {
  window?.addEventListener("scroll", () => {
    rectTop.value = document
      .querySelector(".about__inner-row")
      ?.getBoundingClientRect();
  });
});

onUnmounted(() => {
  clearInterval(intervalId);
});
</script>

<template>
  <div class="about__inner-card d-flex dir-col">
    <div class="about__inner-number">
      <p class="p-16">{{ currentItem }}{{ content?.nonNum }}</p>
    </div>
    <div class="about__inner-teaser">
      <p class="p-16">{{ content?.teaser }}</p>
    </div>
  </div>
</template>

<style lang="scss"></style>
